export const serverURL = process.env.REACT_APP_SERVER_URL || "http://localhost:4000";
// export const serverURL = "http://express-aws-eb.eba-kxz2g5au.ca-central-1.elasticbeanstalk.com"
